// Dependencies
require("webstrap/type");
require("webstrap/grid");

// Styles
require("./avantage.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/avantage/index.js
 ** module id = 127
 ** module chunks = 0 1
 **/